
import { Component, ChangeDetectionStrategy, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallPipe } from 'ngxtension/call-apply';
import { PAGE_COMPONENTS, PageComponent } from '@workbuddy/ui/blocks/page';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AttachmentsComponent, AttachmentsDisplayMode } from '@workbuddy/ui/components/attachments';
import { Activity, Attachment, DomainType, getExtension, isPortal } from '@jms/model';
import { BUTTON_COMPONENTS, ButtonComponent } from '@workbuddy/ui/components/button';
import { iconMap } from '@workbuddy/ui/fields/upload/model';
import { DownloadService } from '@workbuddy/ui/components/attachment';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;


@Component({
    selector: 'activity-preview',
    templateUrl: 'activity.preview.component.html',
    styleUrls: ['activity.preview.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        PageComponent,
        AttachmentsComponent,
        BUTTON_COMPONENTS,
        PAGE_COMPONENTS,
        ButtonComponent,
        CallPipe
    ]
})
export class ActivityPreviewComponent {

    protected activity: Activity;

    protected attachmentId: string = null;
    protected attachmentIcon: string = null;
    protected downloadIcon: string = null;
    protected attachment: Attachment = null;
    protected tenantUrl: string = null;
    protected showDownLoad: boolean = false;

    protected AttachmentsDisplayMode = AttachmentsDisplayMode;

    constructor(
        protected dialog: DynamicDialogRef,
        private config: DynamicDialogConfig,
        private downloadService: DownloadService
    ) {
        this.activity = config.data?.activity;
        this.attachmentId = config.data?.attachmentId;
        this.attachment = this?.activity?.attachments?.find(a => a._id === this.attachmentId);
        this.tenantUrl = config.data?.tenantUrl;

        this.onAttachmentSelected(this.attachment);
    }

    protected onAttachmentSelected(attachment: Attachment): void {
        this.attachment = attachment;
        this.showDownLoadInternal();
        this.getIcon();
    }

    protected getIcon(): void {

        if (!this.attachment) {
            this.attachmentIcon = '';
        }

        if (this?.attachment?.type === 'Form') {
            this.attachmentIcon = 'fa-solid fa-file-lines';
        }

        this.downloadIcon = 'fa-solid fa-download';

        const extension = `.${getExtension(this.attachment?.path)}`;

        const icon = iconMap.get(extension?.toLowerCase()) ?? 'fa-regular fa-file';
        this.attachmentIcon = icon;

    }

    public downloadAttachment(): void {
        this.downloadService.download(this.attachment);
    }

    private showDownLoadInternal() {
        let url = this.attachment?.path as string;
        const isPdf = url.endsWith('pdf');

        this.showDownLoad = !isPdf && this.attachment.type !== 'Form';
    }

    public safeAttachments(attachments: Attachment[]): Attachment[] {
        return isPortal(ConfigService.environment.domainType as any)
            ? attachments.filter(a => a.type !== 'Form')
            : attachments;
    }
}